import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Marquee from "react-fast-marquee";

// components

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats1 from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";
import UserHeader from "components/Headers/AboutHeader.js";
// views

import Dashboard from "views/admin/Dashboard.js";
import Maps from "views/admin/Maps.js";
import Tables from "views/admin/Tables.js";
import User_Management from "views/admin/Profile.js";
import Group_Management from "views/admin/Profile_group";

import Credential from "views/pages/Credentials/Credentials.js";
import Scheduling from "views/pages/Scheduling/List.js";

import Host from "views/pages/HostManagement/List.js";
import Hostlog from "views/pages/HostManagement/Log.js";

import Cloud from "views/pages/CloudManagement/List.js";
import Cloudlog from "views/pages/CloudManagement/Log.js";

import RunAudit from "views/pages/RunAudit/List.js";

import Profile from "components/Cards/CardSettings.js";
import JumpHost from "views/pages/JumphostManagement/Jumphosts.js";
import About from "views/pages/About/About.js";
import HeaderTemplates from "views/pages/HeaderTemplates/Templates.js";
import Audittemplate from "views/pages/Components/AuditTemplate/Detailed.js";

// Audit Component
import Audit from "views/pages/Components/Audit/List";
import Auditdetailedview from "views/pages/Components/Audit/Detailed";
import Auditlog from "views/pages/Components/Audit/Log";

// // Remedy Component
import Remedy from "views/pages/Components/Remedy/List";
import Remedydetailedview from "views/pages/Components/Remedy/Detailed";
import Remedylog from "views/pages/Components/Remedy/Log";

// // Rollback Component
import Rollback from "views/pages/Components/Rollback/List";
import Rollbackdetailedview from "views/pages/Components/Rollback/Detailed";
import Rollbacklog from "views/pages/Components/Rollback/Log";

/// CIS Template
import CisListTemplate from "views/pages/CisTemplates/Templates";
import CisCreateTemplate from "views/pages/CisTemplates/Create";
import CisEditTemplate from "views/pages/CisTemplates/Edit";

/// Timeout session
import IdleTimeOutHandler from "../views/pages/timeOutHandler/IdleTimeOutHandler";

import AuditLicense from "../views/pages/Payment/License"

export default function Admin() {
  return (
    <>
      <Sidebar />
      <AdminNavbar />
      {window.localStorage.getItem("audit_run_limit") ===
      "License limitation crossed" ? (
        <Marquee pauseOnHover="false" style={{ color: "red" }}>
          You have utilized all your trail "Audit", Please contact{" "}
          <a
            href="mailto:sales@zippyops.com"
            style={{ marginLeft: "5px", color: "red", paddingRight: "5px" }}
          >
            sales@zippyops.com
          </a>{" "}
          for subscription.
        </Marquee>
      ) : (
        ""
      )}         
      <div className="md:ml-64 bg-blueGray-100">
       <HeaderStats1 />
    
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
        <IdleTimeOutHandler />
          <Switch>
            <Route path="/admin/dashboard" exact component={Dashboard} />
            <Route path="/admin/maps" exact component={Maps} />
            <Route path="/admin/tables" exact component={Tables} />
            <Route path="/admin/credentials" exact component={Credential} />
            <Route path="/admin/scheduling" exact component={Scheduling} />
            <Route path="/admin/hostmanagement" exact component={Host} />
            <Route path="/admin/hostlog" exact component={Hostlog} />
            <Route path="/admin/cloudmanagement" exact component={Cloud} />
            <Route path="/admin/cloudlog" exact component={Cloudlog} />
            <Route path="/admin/runauditmanager" exact component={RunAudit} />
            <Route path="/admin/jumphostmanagement" exact component={JumpHost} />
            <Route path="/admin/userprofile" exact component={Profile} />
            <Route path="/admin/about" exact component={About} />
            <Route path="/admin/usermanager" exact component={User_Management} />
            <Route path="/admin/groupmanager" exact component={Group_Management} />
            <Route path="/admin/audit" exact component={Audit} />        
            <Route path="/admin/auditlog" exact component={Auditlog} />     
            <Route path="/admin/auditdetailedview" exact component={Auditdetailedview} />  
            <Route path="/admin/remedy" exact component={Remedy} />        
            <Route path="/admin/remedylog" exact component={Remedylog} />     
            <Route path="/admin/remedydetailedview" exact component={Remedydetailedview} />    
            <Route path="/admin/rollback" exact component={Rollback} />        
            <Route path="/admin/rollbacklog" exact component={Rollbacklog} />     
            <Route path="/admin/rollbackdetailedview" exact component={Rollbackdetailedview} />                          
            <Route path="/admin/profile" exact component={CisListTemplate} />  
            <Route path="/admin/makeprofile" exact component={CisCreateTemplate} />  
            <Route path="/admin/editprofile" exact component={CisEditTemplate} />  
            <Route path="/admin/license" exact component={AuditLicense} />  
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>      
      
    </>
  );
}
